export enum TAB_KEY {
  FIRST_STEP = '1',
  RECOMMENDATION = '2',
  APPROVAL_DEVICE = '3',
  CREDENTIALS = '4',
  TERMS_OF_USE = '5',
  ADDRESS = '6',
  DOCUMENT = '7',
  PIN = '8',
  FINAL = '9',
  REPRESENTANTS = '10',
  NEW_REPRESENTANTS = '11',
  MINOR_REPRESENTANTS = '12',
  LEGAL_REPRESENTANTS_DOCUMENT = '13',
  PRIVACY_POLICY = '14',
  ACCEPTANCE_OF_TARIFFS = '15',
  OCCUPATIONS = '16',
  DOCUMENT_CAF = '17',
  IDWALL_VERIFICATION = '18',
}
export enum TaxIdentifierType {
  PF = 1,
  PJ = 2,
}
